import styled from "@emotion/styled";
import { Skeleton } from "@mui/material";

export const Page = styled.main(({ theme }) => ({
	backgroundColor: theme.project.colors.backgroundColors.secondary,
	minHeight: "100vh",
	paddingBottom: 32
}));

export const Header = styled.header(({ theme }) => ({
	background: `linear-gradient(
		90deg,
		${theme.project.colors.primaryColors.main},
		${theme.project.colors.backgroundColors.selected}
	)`,
	padding: "12px 24px",

	[theme.breakpoints.down("sm")]: {
		padding: 16
	}
}));

export const Title = styled.h1(({ theme }) => ({
	...theme.project.typography.heading.h5,
	color: theme.project.colors.fontColors.contrast,
	margin: 0
}));

export const Content = styled.div(({ theme }) => ({
	display: "flex",
	flexDirection: "column",
	gap: 16,
	padding: "12px 16px 24px",

	[theme.breakpoints.down("sm")]: {
		padding: 16
	}
}));

export const EmptyMessage = styled.p(({ theme }) => ({
	...theme.project.typography.body.body2,
	color: theme.project.colors.fontColors.secondary,
	margin: 0
}));

export const ContactSkeletonGrid = styled.div(({ theme }) => ({
	display: "grid",
	gap: 8,
	gridTemplateColumns: "repeat(4, minmax(0, 1fr))",

	[theme.breakpoints.down("lg")]: {
		gridTemplateColumns: "repeat(2, minmax(0, 1fr))"
	},

	[theme.breakpoints.down("sm")]: {
		gridTemplateColumns: "1fr"
	}
}));

export const ContactSkeleton = styled(Skeleton)({
	height: 136,
	transform: "none"
});
